import { render, staticRenderFns } from "./SettingsTableContractsSidebar.vue?vue&type=template&id=c1658b90"
import script from "./SettingsTableContractsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsTableContractsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports